module.exports = __webpack_public_path__ + "img/CT.Tunnels.Tunnel_Lining.Segmental_Lining_with_Reinforcement_Cage.Reinforced_Concrete.6e2b8f8b.png";